module.exports = App.LoyaltyProgram = DS.Model.extend
  name:    DS.attr 'string'
  kind:    DS.attr 'string'
  details: DS.attr()

  selectedKind: null
  additionalInfo: null
  additionalFields: []

  additionalInfoObserver: (-> 
    return unless @get('additionalInfo')

    @set('additionalFields', [])
    kind = @get('kind')
    info = @get('additionalInfo').find (item) => item.name == kind
    return {} if Ember.isEmpty(info)

    fields = info.fields.map (field) =>
      details = @get('details')
      isNumber = field.type in ['Integer', 'Float']
      fieldType = if isNumber then 'isNumber' else "is#{field.type}"
      isSelectable = field.type in ['Select', 'Multiselect']
      fieldText = 
        placeholder: field.locales[Em.I18n.locale]
        label: field.locales[Em.I18n.locale]

      Ember.set(field, fieldType, true)
      Ember.set(field, 'text', fieldText)
      Ember.set(field, 'isSelectable', isSelectable)

      # Предварительно обрабатываем поле, даже если options имеет async контент
      if isSelectable
        Ember.set(field, 'options', [])

        if field.name.includes('ids')
          @store.findAll(field.name.replace('_ids', '')).then (data) =>
            Ember.set(field, 'options', data.toArray())
            # После того как options загружены, обновляем
            @updateFieldValue(field, details)
        else
          options = field.select_options.map (option) => 
            id: option
            name: field.select_locales[option][Em.I18n.locale]

          Ember.set(field, 'options', options)

      # Обрабатываем значение поля только если options уже доступны
      @updateFieldValue(field, details)

      field

    @set('additionalFields', fields)
  ).observes('additionalInfo', 'kind')

  updateFieldValue: (field, details) ->
    return Ember.set(field, 'value', if field.isMultiselect then [] else null) unless details?[field.name]

    if field.isSelectable
      if field.isMultiselect
        value = if field.options?
          field.options.filter (option) =>
            details[field.name].includes(option.id)
        else 
          []
      else
        value = if field.options?
          field.options.find (option) =>
            option.id is details[field.name]
        else 
          null
      Ember.set(field, 'value', value)
    else
      Ember.set(field, 'value', details[field.name])


  programTypeText: (-> 
    return unless @get('additionalInfo')
    kind = @get('kind')
    info = @get('additionalInfo').find (item) => item.name == kind
    info.locales[Em.I18n.locale]
  ).property('kind')
